import { useMemo } from "react";
import { graphql, useSubscription } from "react-relay";

export function useWidgetTaskSingleSubscription(
  routineId: string | undefined,
  taskId: string | undefined,
  skip: boolean
) {
  const shouldSkip = skip || !routineId || !taskId;

  useSubscription(
    useMemo(
      () => ({
        variables: {
          routineIds: routineId ? [routineId] : [],
          taskIds: taskId ? [taskId] : [],
          skip: !!shouldSkip,
        },
        subscription: graphql`
          subscription useWidgetTaskSingleSubscription(
            $taskIds: [ID!]!
            $routineIds: [ID!]!
          ) {
            routineTaskExecutionChanged(
              routineIds: $routineIds
              taskIds: $taskIds
            ) {
              ... on TaskExecutionNumber {
                id
                numberValue
                formattedNumberValue
                updatedAt
              }
              ... on TaskExecutionCheck {
                id
                checkValue
                updatedAt
              }
            }
          }
        `,
      }),
      [routineId, shouldSkip, taskId]
    )
  );
}
